import { useNavigate } from 'react-router-dom';

import { PagePaths } from '@revelio/core';

export const useNavigateToDelivery = () => {
  const navigate = useNavigate();

  return () => {
    navigate(`/${PagePaths.DATA_BUILDER_STATUS}`);
  };
};
